import {
  BalanceAIColoredIcon,
  CloseFullscreen,
  CloseIcon,
  FullscreenOutlinedIcon,
  HistoryIcon,
} from 'common/icons';
import { useTracking } from 'common/utils';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import { MediaQuery } from 'src/theme/media-query';

import { CropwiseAiTabsEnum } from '../cropwise-ai.enum';
import * as Styled from './cropwise-ai-header.style';
import { HistoryPopover } from './history-popover/history-popover.component';

interface CropwiseAiHeaderProps {
  showType: CropwiseAiTabsEnum;
  setShowType: Dispatch<SetStateAction<CropwiseAiTabsEnum>>;
  sessionId: string | null;
  setSessionId: Dispatch<SetStateAction<string | null>>;
}

const CropwiseAiHeader = ({
  showType,
  setShowType,
  sessionId,
  setSessionId,
}: CropwiseAiHeaderProps) => {
  const { t } = useTranslation();
  const { track } = useTracking();

  const isFullScreen = showType === CropwiseAiTabsEnum.FULL_SCREEN;
  const isCollapsed = showType === CropwiseAiTabsEnum.COLLAPSE;
  const isDesktop = useMediaQuery({ minWidth: MediaQuery.screenSizes.desktop });

  const handleClose = () => {
    setShowType(CropwiseAiTabsEnum.HIDE);
  };

  const handleCollapse = () => {
    if (isFullScreen) {
      track('Cropwise AI - Exit Fullscreen');
      setShowType(CropwiseAiTabsEnum.COLLAPSE);
    } else {
      track('Cropwise AI - Enter Fullscreen');
      setShowType(CropwiseAiTabsEnum.FULL_SCREEN);
    }
  };

  if (showType === CropwiseAiTabsEnum.HIDE) {
    return null;
  }

  return (
    <Styled.Container>
      <Styled.LeftContainer>
        <Styled.CropwiseAiTitle $isCollapsed={isCollapsed}>
          <BalanceAIColoredIcon />
          {t('cropwise_ai.title')}
        </Styled.CropwiseAiTitle>
      </Styled.LeftContainer>
      <Styled.ButtonsContainer>
        {(isCollapsed || !isDesktop) && (
          <Styled.HistoryWrapper>
            <HistoryPopover
              showType={showType}
              sessionId={sessionId}
              setSessionId={setSessionId}
            >
              <HistoryIcon />
            </HistoryPopover>
          </Styled.HistoryWrapper>
        )}
        <Styled.Tag onClick={handleCollapse}>
          {isFullScreen ? (
            <>
              <CloseFullscreen />
              {t('cropwise_ai.exit_fullscreen')}
            </>
          ) : (
            <>
              <FullscreenOutlinedIcon />
              {t('cropwise_ai.fullscreen')}
            </>
          )}
        </Styled.Tag>
        <CloseIcon onClick={handleClose} data-testid="modal-close-button" />
      </Styled.ButtonsContainer>
    </Styled.Container>
  );
};

export { CropwiseAiHeader };
